import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { ConductorService } from '../../services/conductor.service';
import { SucursalService } from '../../services/sucursal.service';
import { ApiService } from '../../services/api.service';
import { SucursalDTO } from '../../../dtos/sucursal.dto';
import { GetListaSucursalesResponseDTO } from '../../../dtos/response/getListaSucursales.response.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventService } from '../../services/event.service';
import { GeneralResponseDTO } from '../../../dtos/response/general.response.dto';
import { MovilDTO } from '../../../dtos/movil.dto';
import { CommonModule } from '@angular/common';
import { GetListaMovilesResponseDTO } from '../../../dtos/response/getListaBuses.response.dto';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-cambiar-sucursal-movil',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './modal-cambiar-sucursal-movil.component.html',
  styleUrl: './modal-cambiar-sucursal-movil.component.scss'
})
export class ModalCambiarSucursalMovilComponent implements OnInit {

  public listaMoviles : Array<MovilDTO> = [];
  public movilSeleccionado : MovilDTO = null;
  public listaSucursales: Array<SucursalDTO> = [];
  public sucursalSeleccionada: SucursalDTO;
  public listadoSucursalesDisponibles: Array<SucursalDTO> = [];

  constructor(
    private modalRef: BsModalRef,
    private conductorService: ConductorService,
    private apiService: ApiService,
    private sucursalService: SucursalService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.getListaSucursales();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  getListaMoviles(listaSucursales : SucursalDTO []){

    const sucursalesComoTexto = this.sucursalService.getSucursalesUUIDComoTexto(listaSucursales);

    this.apiService.getListaMoviles(0, 1000000, sucursalesComoTexto).subscribe(
      (resp) => this.getListaMovilesSuccess(resp),
      (error) => this.getListaMovilesError(error)
    );
  }

  getListaMovilesSuccess(getListaMovilesResponseDTO : GetListaMovilesResponseDTO){
    this.listaMoviles = getListaMovilesResponseDTO.data.list;
  }

  getListaMovilesError(error: HttpErrorResponse){
    console.log('error get moviles', error);
    const msg = error.error.msg ? error.error.msg : '';
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe(
      (resp) => this.getListaSucursalesSuccess(resp),
      (error) => this.getListaSucursalesError(error)
    );
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listaSucursales = getListaSucursalesResponseDTO.data;
    this.getListaMoviles(this.listaSucursales);
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    const msg = error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  buscarMovilPorNumeroInternoYPatente(term: string, item: MovilDTO){
    term = term.toLocaleLowerCase();
    if(item.patente.toLocaleLowerCase().indexOf(term) > -1 || item.numeroInterno.toLocaleLowerCase().indexOf(term) > -1){
      return true;
    }else{
      return false;
    }
  }

  cambiarSucursal() {

    if(!this.movilSeleccionado){
      this.toastr.warning("Debe seleccionar un movil", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    if (!this.sucursalSeleccionada) {
      this.toastr.warning("Debe seleccionar una sucursal", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    
    this.apiService.putActualizarSucursalMovil(this.movilSeleccionado.numeroInterno, this.sucursalSeleccionada.uuid)
      .subscribe(res => this.putActualizarSucursalMovilSuccess(res), error => this.putActualizarSucursalMovilError(error));
  }

  putActualizarSucursalMovilSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put sucursal joranda success', generalResponseDTO);
    this.eventService.publish('MOVIL_CAMBIADO_SUCURSAL_EVENT');
    this.close();
  }

  putActualizarSucursalMovilError(error: HttpErrorResponse) {
    console.log('put sucursal jornada error', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoCambiarSucursalMovil(): boolean {
    return this.userService.tienePermiso('MOVIL_CAMBIAR_SUCURSAL');
  }

}
